import { useSalesConfig } from '@apps/card/routes/CardCustomizer/useSalesConfig';
import { StationeryPrintOrderVendorEnum } from '@graphql/generated';
import { useCardCategoryContext } from '../../../../CardCategoryProvider';
import { useCallback } from 'react';
import { isCodeExpired, PromotionConfig } from '@apps/card/routes/CardCustomizer/usePromotionConfig';

const matchesCategoryString = (a: string, b: string) => {
  return a === '*' || a === b;
};

const matchesVendor = (sale: PromotionConfig, filterString: string[]) => {
  const catStrings = sale.categoryList;
  const [occasion, category, vendor] = filterString;

  return catStrings.some(str => {
    const [tOccasion, tCategory, tVendor] = str.split('/');
    return matchesCategoryString(tOccasion, occasion) && matchesCategoryString(tCategory, category) && matchesCategoryString(tVendor, vendor);
  });
};

export const useGetDiscountByVendor = () => {
  const { currentCategory } = useCardCategoryContext();
  const { sales } = useSalesConfig(currentCategory, { occasion: 'wedding', category: currentCategory });

  const getDiscountByVendor = useCallback(
    (vendor: StationeryPrintOrderVendorEnum) => {
      const filteredByVendor = sales?.filter(sale => matchesVendor(sale, ['wedding', currentCategory, vendor]) && !isCodeExpired(sale));
      const bestDiscount = filteredByVendor?.[0];

      return bestDiscount
        ? {
            promoCode: bestDiscount.code,
            type: 'percent' as const,
            percentage: bestDiscount.discountPercentage,
            fullPromoConfig: bestDiscount,
          }
        : undefined;
    },
    [currentCategory, sales],
  );

  return { getDiscountByVendor };
};
